
import base_ from './base/base'
Vue.use(base_)
import global_ from './base/global'
import axios from 'axios'
axios.defaults.withCredentials = false //记录php Session
Vue.config.productionTip = false
axios.interceptors.request.use(function (config) {
  if (config.url.substring(0, 1) === '/') config.url = global_.service + config.url
  return config
}, function (error) {
})
Vue.prototype.axios_ = axios
Vue.prototype.GLOBAL = global_

import './assets/font/iconfont.css'
import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts

import store from './base/store'
// 导航守卫
// 使用 router.beforeEach 注册一个全局前置守卫，判断用户是否登陆
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  document.querySelector('meta[name="keywords"]').setAttribute('content', '网站关键字')
  document.querySelector('meta[name="description"]').setAttribute('content', '网站描述')

  if (to.path === '/admin') {
    next();
  } else {
    let userid = sessionStorage.getItem('verifyData_userid');
    if (userid === null || userid ==='0' || userid ==='') {
      next({path: "/admin"});
    } else {
      next();
    }
  }
});



import Vue from 'vue'
import App from './App'
import router from './router'



// element-ui start
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
// element-ui end

// 引入全局css
import './static/css/main.css'

// import VueWechatTitle from 'vue-wechat-title'
// Vue.use(VueWechatTitle)

Vue.prototype.$tableConHeight = function(result){
  let height = 0
  height = document.body.offsetHeight*1 - 130
  if (height < 300) {
    height = 300
  }
  console.log(height)
  return height
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js